import { render, staticRenderFns } from "./alt-collapse-item.vue?vue&type=template&id=2587e5b2&"
import script from "./alt-collapse-item.vue?vue&type=script&lang=ts&"
export * from "./alt-collapse-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports